import * as React from 'react';
export var TPAComponentsContext = React.createContext({
    mobile: false,
    rtl: false,
    seo: false,
});
export var TPAComponentsProvider = TPAComponentsContext.Provider;
export var TPAComponentsConsumer = TPAComponentsContext.Consumer;
export var useTPAComponentsContext = function () {
    return React.useContext(TPAComponentsContext);
};
//# sourceMappingURL=TPAComponentsConfig.js.map